import React from 'react';

const NotFound = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <h1 className="text-2xl font-bold text-gray-600">404 - 페이지를 찾을 수 없습니다.</h1>
    </div>
  );
};

export default NotFound;
